export const chatConstants = {
    UPDATE_CONVERSATIONS_ALERT: "UPDATE_CONVERSATIONS_ALERT",
    SET_CONVERSATION_ALERT: "SET_CONVERSATION_ALERT",
    SET_CHANNEL_ALERT: "SET_CHANNEL_ALERT",
    MESSAGE_USER_REQUEST: "MESSAGE_USER_REQUEST"
};
